module.exports = __webpack_public_path__ + "img/num_4.adcc2251.png";